import region from './components/region';

const components = [region];

const registerComponent = {
  install: Vue => {
    components.forEach(component => {
      Vue.component(component.name, component);
    });
  }
};

export default registerComponent;
